import React, { useRef } from 'react';
import TriangularGridBackground from '../TriangularGridBackground';
import AnimatedLogo from '../AnimatedLogo';

const LOGO_COLOR = { r: 247, g: 177, b: 0 };

/**
 * Full-screen page with the animated logo on a triangular grid. The button
 * assembles the logo.
 */
function Emina() {
    const logoRef = useRef(null);
    const { r, g, b } = LOGO_COLOR;

    return (
        <div
            style={{
                position: 'relative',
                width: '100%',
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'black'
            }}
        >
            <TriangularGridBackground
                primaryColor={LOGO_COLOR}
                backgroundColor='auto'
                opacity={1}
            />

            <div style={{
                position: 'relative',
                zIndex: 20,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100%',
                paddingTop: '0px',
                paddingBottom: '50px'
            }}>
                <AnimatedLogo
                    ref={logoRef}
                    logoColor={LOGO_COLOR}
                    style={{
                        width: 'min(80vw, 80vh, 800px)',
                        height: 'min(80vw, 80vh, 800px)',
                        maxWidth: '100%',
                        maxHeight: '100%',
                        display: 'block',
                        margin: '0 auto',
                    }}
                />

                <button
                    onClick={() => logoRef.current.assemble()}
                    style={{
                        position: 'absolute',
                        bottom: '5%',
                        left: '49%',
                        transform: 'translateX(-50%)',
                        padding: '18px 40px',
                        fontSize: '16px',
                        fontWeight: '600',
                        border: `2px solid rgba(${r}, ${g}, ${b}, 0.3)`,
                        background: `linear-gradient(135deg,
            rgba(${r}, ${g}, ${b}, 0.1) 0%,
            rgba(${r}, ${g}, ${b}, 0.05) 50%,
            rgba(${r}, ${g}, ${b}, 0.1) 100%)`,
                        backdropFilter: 'blur(10px)',
                        WebkitBackdropFilter: 'blur(10px)',
                        color: `rgb(${r}, ${g}, ${b})`,
                        borderRadius: '50px',
                        cursor: 'pointer',
                        boxShadow: `
            0 8px 32px rgba(${r}, ${g}, ${b}, 0.15),
            inset 0 1px 0 rgba(255, 255, 255, 0.1),
            inset 0 -1px 0 rgba(0, 0, 0, 0.1)
        `,
                        transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                        textTransform: 'uppercase',
                        letterSpacing: '2px',
                        overflow: 'visible',
                        outline: 'none',
                        zIndex: 25,
                        whiteSpace: 'nowrap',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px'
                    }}
                >
                    Mehr erfahren
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        style={{
                            marginLeft: '8px',
                            transition: 'transform 0.3s ease'
                        }}
                    >
                        <path d="M5 12h14M12 5l7 7-7 7" />
                    </svg>
                </button>
            </div>
        </div>
    );
}

export default Emina;
